import { locateRow } from "../find";
import { selectionEquals } from "./equals";
import type { DocumentSection, Selection } from "../types";

export function isSelectionAncestorOf(
  ancestor: Selection,
  descendant: Selection,
  sections: DocumentSection[],
): boolean {
  if (ancestor.kind === 'email' || selectionEquals(ancestor, descendant)) {
    return false;
  }

  if (descendant.kind === 'row') {
    if (ancestor.kind !== 'group') {
      return false;
    }
    const located = locateRow(sections, descendant.rowId);
    return (
      located?.location.parent === 'group' &&
      located.location.groupId === ancestor.groupId
    );
  }

  if (descendant.kind === 'column') {
    if (ancestor.kind === 'row') {
      return ancestor.rowId === descendant.rowId;
    }
    if (ancestor.kind === 'group') {
      const located = locateRow(sections, descendant.rowId);
      return (
        located?.location.parent === 'group' &&
        located.location.groupId === ancestor.groupId
      );
    }
    return false;
  }

  if (descendant.kind === 'block' || descendant.kind === 'buttonRowSlot') {
    const { rowId, columnId } = descendant;
    if (ancestor.kind === 'column') {
      return ancestor.rowId === rowId && ancestor.columnId === columnId;
    }
    if (ancestor.kind === 'row') {
      return ancestor.rowId === rowId;
    }
    if (ancestor.kind === 'group') {
      const located = locateRow(sections, rowId);
      return (
        located?.location.parent === 'group' &&
        located.location.groupId === ancestor.groupId
      );
    }
    if (ancestor.kind === 'block' && descendant.kind === 'buttonRowSlot') {
      return (
        ancestor.rowId === rowId &&
        ancestor.columnId === columnId &&
        ancestor.blockId === descendant.blockId
      );
    }
  }

  return false;
}

export function isImmediateAncestorOf(
  ancestor: Selection,
  descendant: Selection,
  sections: DocumentSection[],
): boolean {
  if (ancestor.kind === 'email' || selectionEquals(ancestor, descendant)) {
    return false;
  }

  if (descendant.kind === 'buttonRowSlot') {
    return (
      ancestor.kind === 'block' &&
      ancestor.rowId === descendant.rowId &&
      ancestor.columnId === descendant.columnId &&
      ancestor.blockId === descendant.blockId
    );
  }

  if (descendant.kind === 'block') {
    return (
      ancestor.kind === 'column' &&
      ancestor.rowId === descendant.rowId &&
      ancestor.columnId === descendant.columnId
    );
  }

  if (descendant.kind === 'column') {
    return ancestor.kind === 'row' && ancestor.rowId === descendant.rowId;
  }

  if (descendant.kind === 'row') {
    if (ancestor.kind !== 'group') {
      return false;
    }
    const located = locateRow(sections, descendant.rowId);
    return (
      located?.location.parent === 'group' &&
      located.location.groupId === ancestor.groupId
    );
  }

  return false;
}

export function hasDescendantHover(
  frame: Selection,
  hover: Selection | null,
  sections: DocumentSection[],
): boolean {
  if (!hover || hover.kind === 'email') {
    return false;
  }
  return isImmediateAncestorOf(frame, hover, sections);
}

export function resolveEffectiveHover(
  _sections: DocumentSection[],
  selection: Selection,
  hover: Selection | null,
): Selection | null {
  if (!hover || selection.kind === 'email') {
    return hover;
  }
  return hover;
}
